import { State } from '../../types';

export const wisconsin: State = {
  name: 'Wisconsin',
  abbreviation: 'WI',
  terms: [
    {
      word: 'Ashwaubenon',
      phonetic: 'ash-WAH-buh-non',
      // audioUrl: '/audio/ashwaubenon.mp3',
      description: 'A village in Brown County, pronounced "ash-WAH-buh-non," not "ash-WAW-bee-non."'
    },
    {
      word: 'Baraboo',
      phonetic: 'BARE-uh-boo',
      // audioUrl: '/audio/baraboo.mp3',
      description: 'A city in Sauk County, pronounced "BARE-uh-boo," not "BAR-uh-boo."'
    },
    {
      word: 'Chequamegon',
      phonetic: 'shuh-WAH-muh-gun',
      // audioUrl: '/audio/chequamegon.mp3',
      description: 'A bay and national forest, pronounced "shuh-WAH-muh-gun," not "CHEK-wah-me-gon."'
    },
    {
      word: 'Kaukauna',
      phonetic: 'kuh-KAW-nuh',
      // audioUrl: '/audio/kaukauna.mp3',
      description: 'A city in Outagamie County, pronounced "kuh-KAW-nuh," not "KOW-kaw-nuh."'
    },
    {
      word: 'Kewaunee',
      phonetic: 'kee-WAH-nee',
      // audioUrl: '/audio/kewaunee.mp3',
      description: 'A city and county, pronounced "kee-WAH-nee," not "KEE-wah-nee."'
    },
    {
      word: 'Manitowoc',
      phonetic: 'MAN-ih-tuh-wok',
      // audioUrl: '/audio/manitowoc.mp3',
      description: 'A city in Manitowoc County, pronounced "MAN-ih-tuh-wok," not "MAN-ih-toe-wok."'
    },
    {
      word: 'Menomonee',
      phonetic: 'meh-NAH-muh-nee',
      // audioUrl: '/audio/menomonee.mp3',
      description: 'As in Menomonee Falls, pronounced "meh-NAH-muh-nee," not "MEN-oh-moh-nee."'
    },
    {
      word: 'Milwaukee',
      phonetic: 'mil-WAH-kee',
      // audioUrl: '/audio/milwaukee.mp3',
      description: 'The largest city in Wisconsin, pronounced "mil-WAH-kee," not "MIL-wah-kee."'
    },
    {
      word: 'Oconomowoc',
      phonetic: 'oh-KAHN-uh-muh-wok',
      // audioUrl: '/audio/oconomowoc.mp3',
      description: 'A city in Waukesha County, pronounced "oh-KAHN-uh-muh-wok," not "oh-KAHN-oh-mowk."'
    },
    {
      word: 'Pewaukee',
      phonetic: 'pee-WAH-kee',
      // audioUrl: '/audio/pewaukee.mp3',
      description: 'A city in Waukesha County, pronounced "pee-WAH-kee," not "PEE-wah-kee."'
    },
    {
      word: 'Prairie du Chien',
      phonetic: 'PRAYR-ee doo SHEEN',
      // audioUrl: '/audio/prairie_du_chien.mp3',
      description: 'A city in Crawford County, pronounced "PRAYR-ee doo SHEEN," not "PRAYR-ee doo CHEE-en."'
    },
    {
      word: 'Racine',
      phonetic: 'ruh-SEEN',
      // audioUrl: '/audio/racine.mp3',
      description: 'A city in Racine County, pronounced "ruh-SEEN," not "RAY-seen."'
    },
    {
      word: 'Sheboygan',
      phonetic: 'shuh-BOY-gun',
      // audioUrl: '/audio/sheboygan.mp3',
      description: 'A city in Sheboygan County, pronounced "shuh-BOY-gun," not "SHE-boy-gan."'
    },
    {
      word: 'Waukesha',
      phonetic: 'WAH-keh-shaw',
      // audioUrl: '/audio/waukesha.mp3',
      description: 'A city in Waukesha County, pronounced "WAH-keh-shaw," not "WAH-kee-shaw."'
    },
    {
      word: 'Wausau',
      phonetic: 'WAH-saw',
      // audioUrl: '/audio/wausau.mp3',
      description: 'A city in Marathon County, pronounced "WAH-saw," not "WAH-soo."'
    },
    {
      word: 'Weyauwega',
      phonetic: 'way-uh-WEE-guh',
      // audioUrl: '/audio/weyauwega.mp3',
      description: 'A city in Waupaca County, pronounced "way-uh-WEE-guh," not "WAY-uh-weh-gah."'
    },
    {
      word: 'Wonewoc',
      phonetic: 'WAH-nee-wok',
      // audioUrl: '/audio/wonewoc.mp3',
      description: 'A village in Juneau County, pronounced "WAH-nee-wok," not "WOH-new-ock."'
    }
  ]
};